import React from "react";
import DocumentsView from "./DocumentsView";

const RFIView = () => <DocumentsView initialTab="rfi" lockedToTab />;

export default RFIView;
